export default __webpack_public_path__ + "static/media/TeamSnap-Email-CTA-Banner.b64a4737.png";